import React from 'react';

import clsx from 'clsx';
import { IconCircle } from 'src/components/icons/IconCircle';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  circle: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.appColors.rule}`,
  },
}));

interface StepIconCircleProps extends React.HTMLAttributes<HTMLElement> {
  icon: React.ReactNode;
}

export function StepIconCircle({ className, ...rest }: StepIconCircleProps): JSX.Element {
  const { classes } = useStyles();

  return <IconCircle className={clsx(classes.circle, className)} {...rest} />;
}
